import _classCallCheck from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { LongPoll, Socket } from 'phoenix';
import { AsyncSubject, EMPTY, timer } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, map, mergeMap, retryWhen, scan } from 'rxjs/operators';
import { getAccessToken } from '@driftt/web-auth';
import { isProduction } from './config/environment';
var SocketAttemptsState = /*#__PURE__*/function () {
  function SocketAttemptsState() {
    _classCallCheck(this, SocketAttemptsState);
    this.attempts = 0;
  }
  _createClass(SocketAttemptsState, [{
    key: "resetStateOnJoin",
    value: function resetStateOnJoin() {
      this.attempts = 0;
    }
  }, {
    key: "setAttempt",
    value: function setAttempt(attempt) {
      this.attempts = attempt;
    }
  }]);
  return SocketAttemptsState;
}();
var RECONNECT_SOCKET_TIMES = [1000, 2000, 5000, 10000];
var REJOIN_CHANNEL_TIMES = [1000, 2000, 5000];
var reconnectAttempts = new SocketAttemptsState();
export var DriftWebSocketConnection = /*#__PURE__*/function () {
  function DriftWebSocketConnection(baseUrl, clusterName, orgId, store) {
    var _this = this;
    _classCallCheck(this, DriftWebSocketConnection);
    this.baseUrl = baseUrl;
    this.clusterName = clusterName;
    this.orgId = orgId;
    this.store = store;
    this.subscribe = function (fun) {
      return _this.socketConnection.subscribe(fun);
    };
    this.socketConnection = this.open();
  }
  _createClass(DriftWebSocketConnection, [{
    key: "shardId",
    get: function get() {
      return this.orgId % 50;
    }
  }, {
    key: "url",
    get: function get() {
      return "".concat(this.orgId, "-").concat(this.shardId, ".").concat(this.baseUrl);
    }
  }, {
    key: "wssBaseUrl",
    get: function get() {
      return "wss://".concat(this.url, "/ws");
    }
  }, {
    key: "apiBaseUrl",
    get: function get() {
      return "https://".concat(this.url);
    }
  }, {
    key: "authParams",
    get: function get() {
      return {
        access_token: getAccessToken()
      };
    }
  }, {
    key: "auth",
    value: function auth() {
      return ajax({
        url: "".concat(this.apiBaseUrl, "/api/auth"),
        method: 'POST',
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.authParams)
      }).pipe(retryWhen(function (errors) {
        return errors.pipe(scan(function (count, error) {
          if (count >= 3) {
            throw error;
          }
          return count + 1;
        }, 0), mergeMap(function (count) {
          return timer(2 ^ count * 1000);
        }));
      }), map(function (data) {
        return Object.assign({}, data.response);
      }), catchError(function () {
        return EMPTY;
      }));
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;
      var sub = new AsyncSubject();
      var obs = this.auth().pipe(map(function (authResponse) {
        var socket = new Socket(_this2.wssBaseUrl, {
          params: {
            session_token: authResponse.session_token
          },
          timeout: 20000,
          reconnectAfterMs: function reconnectAfterMs(attempt) {
            reconnectAttempts.setAttempt(attempt);
            return RECONNECT_SOCKET_TIMES[attempt - 1] || 5000;
          },
          rejoinAfterMs: function rejoinAfterMs(attempt) {
            return REJOIN_CHANNEL_TIMES[attempt - 1] || 5000;
          },
          logger: function logger(kind, msg, data) {
            if (!isProduction) {
              kind === 'transport' && console.log("Drift WS --> ".concat(kind, ": ").concat(msg), data);
            }
          }
        });
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        socket.onClose(function () {});
        // eslint-disable-next-line
        socket.onError(function (error, transport, _establishedConnections) {
          if (transport === WebSocket && reconnectAttempts.attempts > 4) {
            socket.replaceTransport(LongPoll);
            socket.connect();
          } else if (transport === LongPoll) {
            socket.replaceTransport(WebSocket);
            socket.connect();
          }
        });
        socket.connect();
        return socket;
      }));
      obs.subscribe(function (x) {
        reconnectAttempts.resetStateOnJoin();
        sub.next(x);
      }, function (err) {
        sub.error(err);
      }, function () {
        sub.complete();
      });
      return sub;
    }
  }]);
  return DriftWebSocketConnection;
}();